module.exports = __webpack_public_path__ + "static/media/removerConta.a73a0ae8.mp4";